function initServices(section) {
	if (section.dataset.servicesInit === "true") {
		return;
	}

	if (section.dataset.expandAll === "true") {
		section.dataset.servicesInit = "true";
		return;
	}

	const items = section.querySelectorAll(".service-item");
	if (!items.length) {
		return;
	}

	section.dataset.servicesInit = "true";

	const isDesktop = () => window.matchMedia("(min-width: 1024px)").matches;
	let prevButton = items[0];

	function getVisibleIndex() {
		const viewportMid = window.innerHeight / 2;
		let best = 0;
		let bestArea = 0;

		items.forEach((item, i) => {
			const r = item.getBoundingClientRect();
			const overlap = Math.max(
				0,
				Math.min(r.bottom, viewportMid + r.height / 2) -
					Math.max(r.top, viewportMid - r.height / 2)
			);
			if (overlap > bestArea) {
				bestArea = overlap;
				best = i;
			}
		});

		return best;
	}

	function updateMobileInView() {
		if (isDesktop()) {
			return;
		}

		const index = getVisibleIndex();
		const black = "#000";
		const white = "#fff";

		items.forEach((item, i) => {
			const inView = i === index;
			item.classList.toggle("mobile-in-view", inView);

			const title = item.querySelector(".service-item-title");
			const content = item.querySelector(".service-item-content");
			const link = item.querySelector(".service-link");
			const textColor = inView ? white : black;

			if (title) {
				title.style.setProperty("color", textColor, "important");
			}
			if (link) {
				link.style.setProperty("color", textColor, "important");
			}
			if (content) {
				content
					.querySelectorAll("p, .custom-small-text")
					.forEach((el) => {
						el.style.setProperty("color", textColor, "important");
					});
			}
		});
	}

	function clearMobileInlineColors() {
		items.forEach((item) => {
			const title = item.querySelector(".service-item-title");
			const content = item.querySelector(".service-item-content");
			const link = item.querySelector(".service-link");

			if (title) {
				title.style.removeProperty("color");
			}
			if (link) {
				link.style.removeProperty("color");
			}
			if (content) {
				content
					.querySelectorAll("p, .custom-small-text")
					.forEach((el) => {
						el.style.removeProperty("color");
					});
			}
		});
	}

	function updateButtonState(button, isActive) {
		const title = button.querySelector(".service-item-title");
		const content = button.querySelector(".service-item-content");
		const image = button.querySelector(".service-item-bg-image");
		const link = button.querySelector(".service-link");
		if (!title || !content || !image || !link) {
			return;
		}

		button.classList.toggle("is-active", isActive);
		title.classList.toggle("!text-white", isActive);
		title.classList.toggle("!text-dark-blue/50", !isActive);

		if (isActive) {
			title.style.setProperty("color", "#fff", "important");
		} else {
			title.style.removeProperty("color");
			if (title.dataset.originalClasses !== undefined) {
				title.setAttribute("class", title.dataset.originalClasses);
				delete title.dataset.originalClasses;
			}
		}

		content.classList.toggle("opacity-100", isActive);
		content.classList.toggle("max-h-96", isActive);
		content.classList.toggle("opacity-0", !isActive);
		content.classList.toggle("max-h-0", !isActive);
		image.classList.toggle("opacity-100", isActive);
		image.classList.toggle("opacity-0", !isActive);
		link.classList.toggle("block", isActive);
		link.classList.toggle("hidden", !isActive);
		button.style.cursor = isActive ? "default" : "pointer";
	}

	function applyDesktopState() {
		clearMobileInlineColors();
		items.forEach((item) => item.classList.remove("mobile-in-view"));
		prevButton = items[0];
		items.forEach((button, index) => {
			updateButtonState(button, index === 0);
		});
	}

	function applyMobileState() {
		clearMobileInlineColors();
		items.forEach((item) => item.classList.remove("mobile-in-view"));
		items.forEach((button) => {
			button.classList.add("is-active");
			updateButtonState(button, true);
		});
		updateMobileInView();
	}

	items.forEach((button, index) => {
		if (isDesktop()) {
			updateButtonState(button, index === 0);
		} else {
			button.classList.add("is-active");
			updateButtonState(button, true);
		}
	});

	window.addEventListener("scroll", updateMobileInView, { passive: true });
	window.addEventListener("resize", () => {
		if (isDesktop()) {
			applyDesktopState();
		} else {
			applyMobileState();
		}
	});

	if (!isDesktop()) {
		updateMobileInView();
	}

	items.forEach((button) => {
		button.addEventListener("click", () => {
			if (!isDesktop()) {
				return;
			}
			if (prevButton) {
				updateButtonState(prevButton, false);
			}
			updateButtonState(button, true);
			prevButton = button;
		});
	});

	const hoverDarkBlue = "#0a1128";
	items.forEach((item) => {
		item.addEventListener("mouseenter", () => {
			if (!isDesktop() || item.classList.contains("is-active")) {
				return;
			}

			const title =
				item.querySelector(".service-item-title") ||
				item.querySelector("h4");
			if (!title) {
				return;
			}

			const origClass = title.getAttribute("class") || "";
			title.dataset.originalClasses = origClass;
			title.setAttribute(
				"class",
				origClass.replace(/\s*!text-dark-blue\/50/g, "").trim()
			);
			title.style.setProperty("color", hoverDarkBlue, "important");
		});

		item.addEventListener("mouseleave", () => {
			if (!isDesktop() || item.classList.contains("is-active")) {
				return;
			}

			const title =
				item.querySelector(".service-item-title") ||
				item.querySelector("h4");
			if (title && title.dataset.originalClasses !== undefined) {
				title.setAttribute("class", title.dataset.originalClasses);
				title.style.removeProperty("color");
				delete title.dataset.originalClasses;
			}
		});
	});
}

function bootServices() {
	document
		.querySelectorAll("[data-services]")
		.forEach((section) => initServices(section));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootServices);
} else {
	bootServices();
}
